import { EvaluationQuestions } from "#evaluation/components/evaluation/EvaluationQuestions/EvaluationQuestions"
import EvaluationWorkHistories from "#evaluation/components/evaluation/EvaluationWorkHistories"
import { Box } from "@mui/material"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { EvaluationFooter } from "./EvaluationFooter"
import { EvaluationHeader, EvaluationHeaderDefaultValues } from "./EvaluationHeader"
import EvaluationStart from "./EvaluationStart"
import EvaluationTab from "./EvaluationTab"

export default function Evaluation({
	interviewRh = true,
	questions = [],
	values,
	setValues,
	perfilPuesto,
}) {
	const [selectedType, setSelectedType] = useState(0)
	const [candidate, setCandidate] = useState(EvaluationHeaderDefaultValues)
	const [worksHistories, setWorksHistories] = useState([])
	const [observations, setObservations] = useState("")
	const [competences, setCompetences] = useState({})

	useEffect(() => {
		if (typeof setValues !== "function") {
			return
		}
		setValues({
			interview: { evaluator_type: selectedType, observations },
			candidate,
			competences,
			works_histories: worksHistories,
		})
	}, [candidate, competences, observations, selectedType, setValues, worksHistories])

	let itemsTabsNames = ["Inicio de la entrevista", "Preguntas", "Observaciones"]
	let itemsTabs = {
		"Inicio de la entrevista": <EvaluationStart />,
		Preguntas: (
			<EvaluationQuestions
				{...{
					questionsData: questions,
					values: competences,
					setValues: setCompetences,
					perfilPuesto,
				}}
			/>
		),
		Observaciones: (
			<EvaluationFooter
				{...{
					value: observations || "",
					setValue: setObservations,
				}}
			/>
		),
	}

	if (interviewRh) {
		itemsTabsNames.splice(1, 0, "Historial Laboral")
		itemsTabs["Historial Laboral"] = (
			<EvaluationWorkHistories
				{...{ values: worksHistories, setValues: setWorksHistories }}
			/>
		)
	}

	return (
		// <Container maxWidth="lg" sx={{ py: 4 }}>
		<Box p={0}>
			<EvaluationHeader
				{...{ values: candidate, setValues: setCandidate, interviewRh }}
			/>

			<EvaluationTab
				{...{
					typeNames: itemsTabsNames,
					items: itemsTabs,
					selectedType,
					setSelectedType,
				}}
				alternativeText="No hay preguntas disponibles a"
			/>
		</Box>
		// </Container>
	)
}

export const validateDataInterview = (data, interviewRh) => {
	if (interviewRh) {
		for (let check of Object.keys(data["candidate"])) {
			if (data["candidate"][check] === null || data["candidate"][check] === "") {
				toast.error("Se requiere de toda la information del candidato")
				return false
			}
		}
	}
	if (!validateCompetenceQuestions(data["competences"])) return
	if (data["interview"]["observations"] === "") {
		toast.error("Se requiere de las observaciones generales de la entrevista")
		return false
	}

	return true
}
export const validateCompetenceQuestions = (data) => {
	if (Object.keys(data).length === 0) {
		toast.error(`Se requiere de las competencias`)
		return
	}

	for (let key of Object.keys(data || {})) {
		const competence = data[key]
		let answeredQuestions = 0
		for (let questionKey of Object.keys(competence)) {
			if (questionKey === "observation") continue
			if (questionKey === "name") continue
			if (competence[questionKey] != null) {
				answeredQuestions++
			}
		}
		if (answeredQuestions === 0) {
			toast.error(
				`Debe responder al menos una pregunta de la competencia ${competence.name}`,
			)
			return
		}
		// if (competence["observation"] == null || competence["observation"] === "") {
		// 	toast.error("Se requiere de las observaciones de la competencia " + competence.name)
		// 	return
		// }
	}
	return true
}
